var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enter 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.5C2.25 10.0858 2.58579 9.75 3 9.75H12C13.2427 9.75 14.25 8.74267 14.25 7.5V4.5C14.25 4.08578 14.5858 3.75 15 3.75C15.4142 3.75 15.75 4.08578 15.75 4.5V7.5C15.75 9.57105 14.071 11.25 12 11.25H3C2.58579 11.25 2.25 10.9142 2.25 10.5Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46967 11.0303C2.17678 10.7375 2.17678 10.2626 2.46967 9.96968L5.46967 6.96967C5.76257 6.67678 6.23744 6.67678 6.53033 6.96967C6.82322 7.26257 6.82322 7.73745 6.53033 8.03033L4.06066 10.5L6.53033 12.9697C6.82322 13.2625 6.82322 13.7375 6.53033 14.0303C6.23744 14.3232 5.76257 14.3232 5.46967 14.0303L2.46967 11.0303Z",
    fill: "#2D3748"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.a45177ac446cc28569b6a9a6e715d767.svg";
export { ForwardRef as ReactComponent };